import React from 'react';

import AppBar, { AppBarProps } from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { useStyles } from './styles';

export type ComponentProps = {
	open: boolean
	children: React.ReactNode,
	menuPosition?: AppBarProps["position"],
	onClose?(): void
};

const ShowroomMobileActionsMenuLayout = (props: ComponentProps) => {
	const { open, children, menuPosition } = props;
	const { onClose } = props;

	const classes = useStyles();

	return (
		<Slide
			in={open}
			direction='up'
			mountOnEnter
			unmountOnExit
		>
			<AppBar
				position={menuPosition || 'fixed'}
				className={classes.menuAppBar}
			>
				{onClose ? (
					<ClickAwayListener
						onClickAway={() => {
							onClose();
						}}
						touchEvent={false}
					>
						{children}
					</ClickAwayListener>
				) : children}
			</AppBar>
		</Slide>
	);
};

export default React.memo(ShowroomMobileActionsMenuLayout);